import {useRef, useState} from "react";
import SendMessageIcon from "../../../images/icons/SendMessage";
import fileImage from "../../../images/fileImage.png";
import playButt from "../../../images/thumbVideo.png";

import {
  fileFormat,
  MAX_FILE_SIZE,
  MAX_VIDEO_SIZE,
} from "../../../utils/constants";
import {showToastModal} from "../shared/ToastModalSwal";
import {getUploadErrorMessage} from "../../../utils/documentUpload";
import "./proposalStyle.css";

const MessageInput = ({
  onSendMessage,
  userId,
  blocked,
  disabled,
  setLoading,
  loading,
}) => {
  const [message, setMessage] = useState({image: false, text: ""});
  const fileRef = useRef(null);
  // const [loading, setLoading] = useState(false); // You already have this state

  const handleSend = async () => {
    if (blocked || disabled || (!message.text.trim() && !message.imageFile)) return;

    try {
      setLoading(true);
      await onSendMessage(message);
      if (message.imageUri) URL.revokeObjectURL(message.imageUri);
      setMessage({image: false, text: ""});
    } catch (error) {
      if (error?.code === "CONTACT_DISCLOSURE_DETECTED") {
        if (message.imageUri) URL.revokeObjectURL(message.imageUri);
        setMessage({image: false, text: ""});
        showToastModal({
          success: false,
          title: error.accountBlocked
            ? "Compte bloqué"
            : "Partage de coordonnées interdit",
          message:
            error?.message ||
            "Le message a été supprimé. Il est interdit de communiquer une adresse e-mail ou un numéro de téléphone dans la messagerie Help Clic.",
          duration: error.accountBlocked ? 10000 : 9000,
          thenCallback: error.accountBlocked
            ? () => {
                localStorage.removeItem("token");
                localStorage.removeItem("helpclic_web_push_token");
                window.location.assign("/login");
              }
            : undefined,
        });
        return;
      }
      showToastModal({
        success: false,
        title: "Échec de l'envoi",
        message:
          message.imageFile
            ? getUploadErrorMessage(error)
            : error?.message || "Le message n'a pas pu être envoyé.",
        buttonTitle: "Fermer",
      });
    } finally {
      setLoading(false);
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault(); // Prevent a new line in the input
      if (message.text.trim() || message.imageFile) {
        handleSend();
      }
    }
  };

  const handleImage = (e) => {
    const input = e.target;
    if (blocked || disabled) {
      input.value = "";
      return;
    }
    const file = input.files?.[0];
    if (!file) return;

    const validTypes = new Set([
      "image/jpeg",
      "image/png",
      "image/gif",
      "image/webp",
      "video/mp4",
      "video/webm",
      "video/quicktime",
      "application/pdf",
    ]);
    if (!validTypes.has(file.type)) {
      showToastModal({
        success: false,
        title: "Erreur d'importation",
        message:
          "Format non autorisé. Formats acceptés : JPG, JPEG, PNG, GIF, WEBP, MP4, M4V, WEBM, MOV et PDF.",
        buttonTitle: "Ressayer",
      });
      input.value = "";
      return;
    }

    if (file.type.startsWith("video/") && file.size > MAX_VIDEO_SIZE) {
      showToastModal({
        success: false,
        title: "Erreur d'importation",
        message: "La vidéo dépasse la taille maximale autorisée de 20 Mo.",
        buttonTitle: "Ressayer",
      });
      input.value = "";
      return;
    }

    if (!file.type.startsWith("video/") && file.size > MAX_FILE_SIZE) {
      showToastModal({
        success: false,
        title: "Erreur d'importation",
        message: "Le fichier dépasse la taille maximale autorisée de 10 Mo.",
        buttonTitle: "Ressayer",
      });
      input.value = "";
      return;
    }

    let format = fileFormat.OTHER;
    if (file.type === "application/pdf") format = fileFormat.PDF;
    if (file.type.startsWith("video/")) format = fileFormat.VIDEO;
    if (file.type.startsWith("image/")) format = fileFormat.IMAGE;

    const imageUrl = URL.createObjectURL(file);
    setMessage({
      text: "",
      image: true,
      imageUri: imageUrl,
      imageFile: {
        name: file.name,
        type: file.type,
        format,
        size: file.size,
        rawFile: file,
      },
    });
    input.value = "";
  };

  return (
    <>
      {blocked && (
        <div className="p-2 bg-red-300 text-base flex items-center gap-2 justify-center text-red-600 text-center font-medium">
          Cette conversation est bloquée
          <i className="fi fi-rr-octagon-exclamation flex items-center"></i>
        </div>
      )}
      <div className="sm:!p-4   !p-2 flex items-center gap-3 bg-[#F1F2F7] sm:mx-3 rounded-t-2xl">
        <span className="text-base">
          <i
            className="fi fi-rr-clip flex items-center cursor-pointer"
            onClick={() => {
              if (blocked || disabled) return;
              fileRef.current.click();
            }}
          ></i>
        </span>
        <form
          onSubmit={(e) => {
            e.preventDefault();
            if (!loading) handleSend();
          }}
          className={`flex flex-grow bg-white ${
            !blocked ? "opacity-100" : "opacity-50"
          } rounded-xl !py-2 !px-1 sm:!py-3.5 sm:!px-4 items-center`}
        >
          {message.image && (
            <div className="flex items-center gap-2 justify-start flex-grow">
              <div className="ml-3 relative text-lg text-red-600">
                <div className="bg-red-600 rounded-full w-5 h-5 flex absolute -top-2 -right-2 justify-center items-center text-white cursor-pointer">
                  <i
                    className="fi fi-rr-cross-small flex items-center"
                    onClick={() => {
                      if (message.imageUri) URL.revokeObjectURL(message.imageUri);
                      setMessage((prev) => ({image: false, text: prev.text}));
                    }}
                  ></i>
                </div>
                {message.imageFile?.type.includes("video") ? (
                  <img
                    src={playButt}
                    alt="Preview"
                    className="h-10  object-cover rounded-md"
                  />
                ) : message.imageFile?.type.includes("application") ? (
                  <img
                    src={fileImage}
                    alt="Preview"
                    className="h-10 aspect-square object-cover rounded-md"
                  />
                ) : (
                  <img
                    src={message.imageUri}
                    alt="Preview"
                    className="h-10 aspect-square object-cover rounded-md"
                  />
                )}
              </div>
              <span className="text-[10px] text-[#7e7e7e] flex-grow truncate">
                {message.imageFile?.name}
              </span>
            </div>
          )}
          <input
            type="file"
            className="hidden"
            multiple={false}
            disabled={!!blocked || disabled}
            ref={fileRef}
            onChange={handleImage}
            accept=".jpg,.jpeg,.png,.gif,.webp,.mp4,.m4v,.webm,.mov,.pdf"
          />
          <input
            type="text"
            value={message.text}
            disabled={!!blocked || disabled || message.image}
            onChange={(e) =>
              setMessage((prev) => ({...prev, text: e.target.value}))
            }
            onKeyDown={handleKeyDown}
            placeholder="Écrivez un message..."
            className={`flex-grow  border-none ${
              message.image ? "max-w-0 opacity-0  " : ""
            }`}
            // onKeyDown={handleKeyDown}
          />
          <button
            type="submit"
            disabled={disabled || loading || blocked}
            className="bg-transparent border-none cursor-pointer"
          >
            <SendMessageIcon
              className={"fill-blue-600 w-6 h-6 cursor-pointer"}
              // onClick={() => {
              //   if (!loading) handleSend();
              // }}
            />
          </button>
        </form>
      </div>
    </>
  );
};

export default MessageInput;
